import React, {memo, useState} from 'react';
import { useTranslation } from 'react-i18next';
import Card from './card';
import Avatar from '../../../components/helper/avatar';
import ImgIconComp from "../../../components/imgcomp";
import ConfirmModal from '../../../styled-base/modal/implementations/confirm-modal';
import {deleteCard} from '../../actions/card.actions';
import {useDispatch} from 'react-redux';
import moment from 'moment';
import {PeopleCardProps} from '../../types/people.types';
import UserInfoModal from '../../modals/user-info';
import { Draggable } from "react-beautiful-dnd";

const PeopleCard = ({ card, columnId, index, user, userPermission, boardInfo }: PeopleCardProps) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const editCard: boolean = (userPermission.editBoard == "1");
    const [showDeleteIcon, showDeleteButton] = useState<boolean>(false);
    const [openDeletePopup, setOpenDeletePopup] = useState(false);
    const [openUserInfo, setUserInfo] = useState<boolean>(false);

    const firstName = card.firstname ? card.firstname : '';
    const lastName = card.lastname ? card.lastname : '';
    const title = card.title && card.title.trim() ? card.title : '';
    let availabiltyDate: number = parseInt(card.user_availabilty_date);
    let dateText: string = '';
    if (!isNaN(availabiltyDate) && availabiltyDate > 0) {
        const _userOffset = user.currentDate.userOffset || 0;
        if (typeof _userOffset !== "undefined" && _userOffset !== null) {
            availabiltyDate += parseInt(_userOffset);
        }
        dateText = moment.utc(availabiltyDate * 1000).format("M/D");
    }

    const deleteParticularCard = (e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        if (!editCard) return;
        setOpenDeletePopup(true);
    }

    const onAcceptDeleteUser = () => {
        if (!editCard) return;
        setOpenDeletePopup(false);
        dispatch(deleteCard(columnId, card.id));
    }

    const userDetailsPopup = (e?: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        if (!editCard) return;
        setUserInfo(true);
    }

    const getItemStyle = (isDragging: boolean, draggableStyle:any) => {
        const {transform, ...rest} = draggableStyle;
        let style = {
            // some basic styles to make the items look a bit nicer
            userSelect: "none",
            // styles we need to apply on draggables
            ...draggableStyle,
        }
        if(isDragging && transform){
            let containerCoordinates = document.querySelector(".mainBoardWrapper").getBoundingClientRect();
            
            let trArray = transform.substring(10, transform.length -1).split(",");
            let transX = draggableStyle.left + parseInt(trArray[0].trim().substring(0, trArray[0].length-2));
            let transY = draggableStyle.top + parseInt(trArray[1].trim().substring(0, trArray[1].length-2));
    
            if(transY < containerCoordinates.top - 10 ){
                if(transX > containerCoordinates.left){
                    style.transform = `translate(${transX - draggableStyle.left}px, -${draggableStyle.top-(containerCoordinates.top - 10)}px)`;
                }else{
                    style.transform = `translate(-${draggableStyle.left-containerCoordinates.left}px, -${draggableStyle.top-(containerCoordinates.top - 10)}px)`;
                }
                
            }else if(transX < containerCoordinates.left){
                style.transform = `translate(-${draggableStyle.left-containerCoordinates.left}px, ${transY - draggableStyle.top}px)`;
            }else{
                style.transform = transform;
            }
        }
        return style;
    };

    return (
    <div>
        <Draggable draggableId={`drag-item-${columnId}-${card.id}`} index={index} >
        {
            (provided:any, snapshot:any) => (
            <div 
                {...provided.draggableProps} 
                {...provided.dragHandleProps} 
                ref={provided.innerRef}
                style={getItemStyle(
                    snapshot.isDragging,
                    provided.draggableProps.style
                  )} 
                >
                <Card
                    onMouseOver={() => {editCard ? showDeleteButton(true) : false}}
                    onMouseOut={() => {editCard ? showDeleteButton(false) : false}}
                    onClick={userDetailsPopup}
                >
                    <Card.Body>
                        <div className='people-card'>
                            <div
                                className={"people-delete-button delete-" + card.id}
                                onClick={(e) => deleteParticularCard(e)}
                                style={{display: showDeleteIcon ? 'block' : ' none'}}
                            >
                                <ImgIconComp id="delete_image" width="12" height="12" />
                            </div>
                            <div className='people-member-image' >
                                <Avatar  src={card.picture} imageClass="people-member-profile" useSpriteSheet={false} />
                                <div className='people-member-avail truncateText'>
                                    {dateText}
                                </div>
                            </div>
                            <div className='people-member-details' style={{ top : title !==''? 6 : -3 }}>
                                <div className='people-member-name truncateText'>
                                    {`${firstName} ${lastName}`}
                                </div>
                                <div className='people-member-title truncateText'>{title}</div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </div>
            )
        }
        </Draggable>
        {
              openDeletePopup ?
              <ConfirmModal
                acceptText={t("Yes")}
                declineText={t("Cancel")}
                title={t("Confirm Deletion")}
                onDecline={() => setOpenDeletePopup(false)}
                onAccept={onAcceptDeleteUser}
              >
                <div>
                    {t("Are you sure you want to delete the user?")}
                </div>
              </ConfirmModal>
            :''
        }
        {
            openUserInfo ?
                <UserInfoModal
                    item={card}
                    boardInfo={boardInfo}
                    onClose={() => setUserInfo(false)}
                />
            : ''
        }
    </div>
    )
}

export default memo(PeopleCard);
